module.exports = __webpack_public_path__ + "static/media/light_blue_dot.73c83928.png";